module.exports = __webpack_public_path__ + "static/media/esquema-nacional-interoperabilidad.47c3cea6.svg";